import React from 'react'
import SpeechToTextHeroSection from './SpeechToTextHeroSection'
import ProblemSolutionSection from './ProblemSolutionSection'
import SpeechToTextKeyFeatures from './SpeechToTextKeyFeatures'
import AdvancedCapabilities from './AdvancedCapabilities'
import BuiltForRealWorldUse from './BuiltForRealWorldUse'
import EnterpriseGradeFeatures from './EnterpriseGradeFeatures'

function SpeechToText() {
    return (
        <div>
            <SpeechToTextHeroSection />
            <ProblemSolutionSection />
            <SpeechToTextKeyFeatures />
            <AdvancedCapabilities />
            <BuiltForRealWorldUse />
            <EnterpriseGradeFeatures />
        </div>
    )
}

export default SpeechToText
